"use client";

import { AutoGPTLogo } from "@/components/atoms/AutoGPTLogo/AutoGPTLogo";
import {
  SidebarHeader,
  useSidebar,
} from "@/components/molecules/Sidebar/Sidebar";
import { cn } from "@/lib/utils";
import Link from "next/link";
import { SidebarLeftIcon } from "@hugeicons/core-free-icons";
import { Icon } from "@/components/atoms/Icon/Icon";

export function TourSidebarHeader() {
  const { state, toggleSidebar } = useSidebar();
  const isCollapsed = state === "collapsed";

  const toggleButton = (
    <button
      type="button"
      aria-label={isCollapsed ? "Expand sidebar" : "Collapse sidebar"}
      onClick={toggleSidebar}
      className={cn(
        "size-8 shrink-0 items-center justify-center rounded-md text-foreground-emphasis transition-colors hover:bg-surface-active",
        isCollapsed
          ? "absolute inset-0 hidden group-focus-within:flex group-hover:flex"
          : "flex",
      )}
    >
      <Icon icon={SidebarLeftIcon} className="size-5" />
    </button>
  );

  return (
    // oxlint-disable-next-line design-system/no-restyle -- one-off mount fade; SidebarHeader has no motion variant
    <SidebarHeader className="flex animate-fade-in flex-row items-center justify-between group-data-[collapsible=icon]:flex-col" data-sentry-element="SidebarHeader" data-sentry-component="TourSidebarHeader" data-sentry-source-file="TourSidebarHeader.tsx">
      <div
        className={cn(
          "relative flex items-center",
          isCollapsed && "size-8 shrink-0",
        )}
      >
        <Link
          href="/marketplace"
          aria-label="AutoGPT"
          className={cn(
            "flex items-center",
            isCollapsed &&
              "size-8 items-center justify-center group-focus-within:hidden group-hover:hidden",
          )}
        data-sentry-element="Link" data-sentry-source-file="TourSidebarHeader.tsx">
          {isCollapsed ? (
            <AutoGPTLogo hideText viewBox="47 -1 42 42" className="size-8" />
          ) : (
            <AutoGPTLogo className="h-9 w-auto" />
          )}
        </Link>
        {isCollapsed ? toggleButton : null}
      </div>

      {isCollapsed ? null : toggleButton}
    </SidebarHeader>
  );
}
